import API from '../../services/API'

// Thin wrappers over the course engine API (docs/training/ENGINE-API.md).
// API never rejects on 4xx/5xx, so every caller checks `res.status`. Routes
// that create something answer 201.

export const isOk = (res) => res?.status === 200 || res?.status === 201
export const errorMessage = (res, fallback = 'Something went wrong. Please try again.') =>
  res?.data?.error || fallback

// The player handles locked/refused actions itself (409s), so these calls
// opt out of the app-wide error popup.
const quiet = { skipGlobalErrorHandler: true }

export const getMyCourses = () => API.get('/training/my-courses', quiet)
export const startCourse = (courseId, options = {}) =>
  API.post('/training/enrolments', { courseId, ...options }, quiet)
export const getEnrolment = (enrolmentId) => API.get(`/training/enrolments/${enrolmentId}`, quiet)
export const postProgress = (enrolmentId, body) =>
  API.post(`/training/enrolments/${enrolmentId}/progress`, body, quiet)
export const startAttempt = (enrolmentId) =>
  API.post(`/training/enrolments/${enrolmentId}/attempts`, {}, quiet)
export const submitAttempt = (attemptId, answers) =>
  API.post(`/training/attempts/${attemptId}/submit`, { answers }, quiet)
export const submitFeedback = (enrolmentId, body) =>
  API.post(`/training/enrolments/${enrolmentId}/feedback`, body, quiet)
export const issueCertificate = (enrolmentId) =>
  API.post(`/training/enrolments/${enrolmentId}/certificate`, {}, quiet)
export const getCertificate = (certificateId) => API.get(`/training/certificates/${certificateId}`, quiet)
export const getQuestionBank = (enrolmentId) => API.get(`/training/enrolments/${enrolmentId}/bank`, quiet)
export const verifyCertificate = (verificationId) =>
  API.get(`/training/verify/${encodeURIComponent(verificationId)}`, quiet)

// Admin
export const getCatalogue = () => API.get('/training/admin/catalogue')
export const updateCourseLink = (courseId, body) => API.put(`/training/admin/courses/${courseId}`, body)
export const addCatalogueCourse = (catalogueCode) =>
  API.post('/training/admin/courses/from-catalogue', { catalogueCode })
export const getMatrix = () => API.get('/training/admin/matrix')
export const getMatrixCsv = () =>
  API.get('/training/admin/matrix', { params: { format: 'csv' }, responseType: 'blob' })
export const chaseStaff = (courseId, employeeIds) =>
  API.post('/training/admin/chase', { courseId, employeeIds })
export const assignCourse = (body) => API.post('/training/admin/assignments', body)
export const withdrawAssignment = (enrolmentId) => API.delete(`/training/admin/assignments/${enrolmentId}`)
export const getEmployeeELearning = (employeeId) => API.get(`/training/admin/employees/${employeeId}`, quiet)
export const recordPracticalSignoff = (body) => API.post('/training/admin/practical-signoffs', body)
export const revokeCertificate = (certificateId, reason) =>
  API.post(`/training/admin/certificates/${certificateId}/revoke`, { reason })
export const getTimeOnTask = () => API.get('/training/admin/time-on-task', quiet)
